export const EVENT = {
  CARD_PRIMARY_BUTTON_CLICKED: 'Card primary button clicked',
  CARD_SECONDARY_BUTTON_CLICKED: 'Card secondary button clicked',
};
